import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useDevelop = ({ handleMuestraSnack, pidDevelopment = 0 }) => {
  const [ejecutaapi] = Api();
  const [developments, setDevelopments] = useState([]);
  const [idDevelopment, setIdDevelopment] = useState();

  const onChangeDevelopment = value => {
    setIdDevelopment(value);
  };

  const getDevelopments = () => {
    let body = JSON.stringify({
      pIdDesarrollo: pidDevelopment
    });

    ejecutaapi("obtienedesarrollos", body).then(data => {
      let { result, error } = ValidationResponse(data);
      if (result != null) setDevelopments(result);
      if (error !== "")
        handleMuestraSnack && handleMuestraSnack(error, "error");
    });
  };
  return {
    developments,
    getDevelopments,
    onChangeDevelopment,
    idDevelopment
  };
};

export default useDevelop;
